import Modules from '../components/Modules'
import { useDocumentTitle } from '../utils/hooks'

export default function SurveyPage() {
  useDocumentTitle('22-17040 P&G Consumables - Survey Modules')
  return <Modules />
}
